import { useEffect, useState } from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { AuditTable } from "./case/ActivityTabs";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [verify, setVerify] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)); api.get("/audit/verify").then((r) => setVerify(r.data)); }, []);
  return (
    <div className="page space-y-6" data-testid="audit-page">
      <div className="flex items-end justify-between gap-4">
        <div><div className="eyebrow">Immutable Audit Log</div><h1 className="text-3xl font-bold text-slate-900 mt-1">Every action, hash-chained</h1><p className="text-sm text-slate-600 mt-1">Logins, document views, AI outputs and reviews, overrides, and decisions. Each entry's SHA-256 hash includes the previous hash.</p></div>
        {verify && <div className={`panel px-4 py-3 flex items-center gap-3 ${verify.valid ? "text-emerald-700" : "text-rose-700"}`} data-testid="audit-verify">{verify.valid ? <ShieldCheck className="h-5 w-5" /> : <ShieldAlert className="h-5 w-5" />}<div><div className="text-sm font-semibold">{verify.valid ? "Chain verified" : `Chain broken at #${verify.broken_at_seq}`}</div><div className="mono text-xs text-slate-500">{verify.entries} entries · head {verify.head_hash?.slice(0, 16)}</div></div></div>}
      </div>
      <AuditTable items={items} title="All entries (newest first)" />
    </div>
  );
}
